module.exports = __webpack_public_path__ + "static/img/g4.545071f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/g4.png
// module id = M2v+
// module chunks = 1